'use strict';

require("core-js/modules/es6.object.is");

var getPolyfill = require('./polyfill');

var define = require('define-properties');

module.exports = function shimObjectIs() {
  var polyfill = getPolyfill();
  define(Object, {
    is: polyfill
  }, {
    is: function testObjectIs() {
      return Object.is !== polyfill;
    }
  });
  return polyfill;
};